import toolkit from '@/app/mixins/toolkit/item';
import pension from '@/app/mixins/toolkit/pension/pension';
import { dollar } from '@/app/filters/filters';
import { getFormattedMemberName } from '@/app/utils/utils';

export default {
  name: 'member-letter',
  mixins: [toolkit, pension],
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    pensionKit() {
      return this.$store.getters['toolkit/getItemData'];
    },
    startDate() {
      return this.pensionKit.requirements.startDate;
    },
    pension() {
      if (this.pensionKit.pensions !== null && this.pensionKit.pensions.length > 0) {
        return this.pensionKit.pensions[0];
      }
      return null;
    },
    displayPensionStartReason() {
      if (this.pension === null) {
        return '';
      }

      let pensionType = 'retirement phase account-based pension (“the pension”)';
      if (this.isTris) {
        pensionType = 'transition to retirement pension';
      }
      const reasons = {
        "The whole balance of the pensioner's accumulation account":
          `a ${pensionType} with the full balance of my accumulation account`,
        "The balance of the pensioner's accumulation account less a fixed amount": `a ${pensionType} with the balance of my accumulation account less ${dollar(this.pensionFixedAmount)}`,
        'As much as possible without going over the transfer balance cap':
          `a ${pensionType} with as much as possible of my accumulation account without causing me to exceed my transfer balance cap at that time`,
        'A fixed amount': `a ${pensionType} with a fixed amount of ${dollar(this.pensionFixedAmount)}`,
      };

      return reasons[this.pensionKit.setup.howMuch];
    },
    displayConditionOfReleaseWording() {
      if (this.pensionKit.requirements.member.age >= 65) {
        return 'I confirm that I have reached age 65 and am eligible to access my superannuation.';
      }
      const releases = {
        'The pension will be a transition to retirement pension': '',
        'Permanently retired': `I am over ${this.pensionKit.requirements.member.preservationAge} (my “preservation age”), I ended a period of gainful employment prior to this pension commencing, and I do not intend to work 10 or more hours per week in any form of paid employment in the future.  I understand that I am therefore eligible to access my superannuation.`,
        'Ended a paid work arrangement after turning 60':
          'I ended a period of gainful employment after my 60th birthday and am therefore eligible to access all of my superannuation that had accrued before my gainful employment ended.',
        'Suffering from a terminal medical condition':
          'I am suffering from a terminal medical condition and am therefore able to access my superannuation at any time.  Any necessary medical certificates have been provided.',
        'Permanently incapacitated':
          'I have become permanently incapacitated and am therefore able to access my superannuation at any time.  Any necessary medical certificates have been provided.',
        other: `I am eligible to convert this amount to a pension because ${this.pensionKit.requirements.eligibility.otherReason}`,
      };

      return releases[this.pensionKit.requirements.eligibility.reasons];
    },
    displayReversionaryBeneficiaryWording() {
      let paragraph = '';
      if (
        this.pension === null
        || this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === undefined
      ) {
        return '';
      }
      if (this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === 'No') {
        paragraph = 'On my death, my pension should cease – I do not wish to nominate a reversionary beneficiary to continue receiving my pension.';
      } else {
        const relationship = this.pension.reversionaryBeneficiary.beneficiaryDetails.relationship
          === 'Other allowable beneficiary'
          ? this.pension.reversionaryBeneficiary.beneficiaryDetails.otherRelationship
          : this.pension.reversionaryBeneficiary.beneficiaryDetails.relationship;
        const person = getFormattedMemberName(
          this.pension.reversionaryBeneficiary.beneficiaryDetails,
        );
        const formattedRelationship = relationship[0].toLowerCase() + relationship.slice(1);
        paragraph = `On my death, my pension should continue to my ${formattedRelationship}, ${person}.`;
        if (this.pension.reversionaryBeneficiary.beneficiaryDetails.relationship !== 'Spouse') {
          paragraph
            += ' If superannuation law does not allow this beneficiary to receive a pension from my superannuation at the time of my death then my pension should cease on my death.';
        }
      }

      return paragraph;
    },
    displayTrustDeedClause() {
      if (
        this.pension === null
        || this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === undefined
      ) {
        return '';
      }
      if (
        this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === 'Yes'
        && this.pension.reversionaryBeneficiary.hasTrustDeed === 'Yes'
      ) {
        return 'I understand that the continuation of my pension will not depend on any action carried out, or discretion exercised, by the trustee. It will also not be subject to any other death benefit nominations (including nominations classified as “binding”) I make for my superannuation benefits unless the law or some other factor prevents my pension from continuing to my beneficiary.';
      }
      return '';
    },
    displaySegregationWording() {
      if (
        this.pension === null
        || this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === undefined
      ) {
        return '';
      }
      let paragraph = '';
      if (this.pension.segregation.hasSegregation === 'Yes') {
        paragraph = 'I would like the attached list of assets to be specifically set aside for the purposes of providing my pension.';
        if (this.pension.segregation.segregatedPensionAssets === 'Yes') {
          paragraph
            += ' Where possible, I would like these assets to also be treated as segregated pension assets for tax purposes.';
        }
        if (this.pension.segregation.pensionAssets === 'Yes') {
          paragraph
            += ' To the extent that these assets are not sufficient to support my pension in full, the remainder of my pension account should be supported by a share of the fund’s remaining assets.';
        }
      }

      return paragraph;
    },
  },
};
